import { format, getYear, isValid } from 'date-fns'

/**
 * SDK sentinel for "no time set" (`DateTime.MinValue`). Sending it as
 * `manualStartTime`/`manualEndTime` clears that side of the schedule; the API
 * hands it back for events that never had one.
 */
export const CLEARED_TIME = '0001-01-01T00:00:00.0000000+00:00'

/** True for the sentinel above, whichever precision/offset the API formats it with. */
export const isClearedTime = (value?: string | null) => {
  if (!value) {
    return true
  }

  const date = new Date(value)

  return !isValid(date) || getYear(date) <= 1
}

/** Value shape of an `<input type="datetime-local">`, i.e. local time without a zone. */
const DATE_TIME_INPUT_FORMAT = "yyyy-MM-dd'T'HH:mm"

/** ISO string → `datetime-local` value. Empty for a missing or cleared time. */
export const toDateTimeInput = (iso?: string | null) =>
  isClearedTime(iso) ? '' : format(new Date(iso as string), DATE_TIME_INPUT_FORMAT)

/** `datetime-local` value → ISO string. Empty input stays empty (i.e. "not set"). */
export const fromDateTimeInput = (value: string) => (value ? new Date(value).toISOString() : '')

/**
 * True when both sides are set and the end does not lie after the start — a
 * zero-length or reversed range. An open end (`null`) or a missing start is not
 * a conflict, those are their own states.
 */
export const isEndNotAfterStart = (start?: string | null, end?: string | null) => {
  if (isClearedTime(start) || end == null || isClearedTime(end)) {
    return false
  }

  return new Date(end as string).getTime() <= new Date(start as string).getTime()
}
